var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed-header-button"},[_c('v-flex',{attrs:{"md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","justify-end":""}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }